import tmsTools from './tmsTools';

export default {
    enableLogs() {
        tmsTools.setCookie('gptPrintLog', '1', 365);
        location.reload(true);
    },
    disableLogs() {
        tmsTools.removeCookie('gptPrintLog');
        location.reload(true);
    },
};
